/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
type CeoHomePage_viewer$ref = any;
export type CeoHomePage_QueryVariables = {
    readonly customUrl: string;
};
export type CeoHomePage_QueryResponse = {
    readonly viewer: ({
        readonly id: string | null;
        readonly " $fragmentRefs": CeoHomePage_viewer$ref;
    }) | null;
};
export type CeoHomePage_Query = {
    readonly response: CeoHomePage_QueryResponse;
    readonly variables: CeoHomePage_QueryVariables;
};



/*
query CeoHomePage_Query(
  $customUrl: String!
) {
  viewer {
    id
    ...CeoHomePage_viewer_4p0U5i
  }
}

fragment CeoHomePage_viewer_4p0U5i on Viewer {
  user {
    id
    userId
    ...CeoProfile_user
    role
    publicId
    cart {
      id
      eventId
    }
    shoppingWithCeoUser {
      publicId
      id
    }
    ceo(customUrl: $customUrl) {
      id
      userId
      publicId
      firstName
      disableJoinMyTeam
      lastName
      trinityDealerId
      profile {
        image
        summary
        city
        state
        zip
        id
      }
    }
  }
}

fragment CeoProfile_user on User {
  ...EventsDropDown_user
  shoppingWithCeoUser {
    userId
    firstName
    id
  }
}

fragment EventsDropDown_user on User {
  ...DropDownAutoComplete_user
}

fragment DropDownAutoComplete_user on User {
  ...AuthDialog_user
  id
  userId
  publicId
  permissions {
    id
    oneCommerce {
      id
      ceo {
        access
      }
    }
  }
  shoppingWithCeoUser {
    publicId
    id
  }
  DropDownAutoCompleteData: autoCompleteData(first: 25, ceoId: "none", searchCEOS: false, searchEvents: false, searchProducts: false) {
    edges {
      cursor
      node {
        id
        isCEO
        image
        ceoId
        isEvent
        isProduct
        routePath
        primaryLabel
        secondaryLabel
        productCategory
        __typename
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment AuthDialog_user on User {
  id
  role
  email
  lastName
  firstName
  hasSSOAccount
  shoppingWithCeoUser {
    userId
    id
  }
  cart {
    id
    eventId
    eventHostFirstName
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "customUrl",
            "type": "String!",
            "defaultValue": null
        } as any)
    ], v1 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "lastName",
        "args": null,
        "storageKey": null
    } as any), v3 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "firstName",
        "args": null,
        "storageKey": null
    } as any), v4 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "userId",
        "args": null,
        "storageKey": null
    } as any), v5 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "publicId",
        "args": null,
        "storageKey": null
    } as any), v6 = [
        ({
            "kind": "Literal",
            "name": "ceoId",
            "value": "none",
            "type": "String"
        } as any),
        ({
            "kind": "Literal",
            "name": "first",
            "value": 25,
            "type": "Int"
        } as any),
        ({
            "kind": "Literal",
            "name": "searchCEOS",
            "value": false,
            "type": "Boolean"
        } as any),
        ({
            "kind": "Literal",
            "name": "searchEvents",
            "value": false,
            "type": "Boolean"
        } as any),
        ({
            "kind": "Literal",
            "name": "searchProducts",
            "value": false,
            "type": "Boolean"
        } as any)
    ], v7 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "image",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "CeoHomePage_Query",
            "type": "Root",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        (v1 /*: any*/),
                        {
                            "kind": "FragmentSpread",
                            "name": "CeoHomePage_viewer",
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "customUrl",
                                    "variableName": "customUrl",
                                    "type": null
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "CeoHomePage_Query",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        (v1 /*: any*/),
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "user",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "User",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "hasSSOAccount",
                                    "args": null,
                                    "storageKey": null
                                },
                                (v1 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "role",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "email",
                                    "args": null,
                                    "storageKey": null
                                },
                                (v2 /*: any*/),
                                (v3 /*: any*/),
                                (v4 /*: any*/),
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "shoppingWithCeoUser",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "User",
                                    "plural": false,
                                    "selections": [
                                        (v4 /*: any*/),
                                        (v1 /*: any*/),
                                        (v5 /*: any*/),
                                        (v3 /*: any*/)
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "cart",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Cart",
                                    "plural": false,
                                    "selections": [
                                        (v1 /*: any*/),
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "eventId",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "eventHostFirstName",
                                            "args": null,
                                            "storageKey": null
                                        }
                                    ]
                                },
                                (v5 /*: any*/),
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "permissions",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "PermissionsType",
                                    "plural": false,
                                    "selections": [
                                        (v1 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "oneCommerce",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "OneCommerceType",
                                            "plural": false,
                                            "selections": [
                                                (v1 /*: any*/),
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "ceo",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "AccessType",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "access",
                                                            "args": null,
                                                            "storageKey": null
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": "DropDownAutoCompleteData",
                                    "name": "autoCompleteData",
                                    "storageKey": "autoCompleteData(ceoId:\"none\",first:25,searchCEOS:false,searchEvents:false,searchProducts:false)",
                                    "args": (v6 /*: any*/),
                                    "concreteType": "AutoCompleteEntryConnection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "edges",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "AutoCompleteEntryEdge",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "cursor",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "node",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "AutoCompleteDataEntry",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "isProduct",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        (v1 /*: any*/),
                                                        (v7 /*: any*/),
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "ceoId",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "isEvent",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "isCEO",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "routePath",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "primaryLabel",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "secondaryLabel",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "productCategory",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "__typename",
                                                            "args": null,
                                                            "storageKey": null
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "pageInfo",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "PageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "endCursor",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "hasNextPage",
                                                    "args": null,
                                                    "storageKey": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedHandle",
                                    "alias": "DropDownAutoCompleteData",
                                    "name": "autoCompleteData",
                                    "args": (v6 /*: any*/),
                                    "handle": "connection",
                                    "key": "DropDownAutoComplete_DropDownAutoCompleteData",
                                    "filters": [
                                        "ceoId",
                                        "inputValue",
                                        "searchCEOS",
                                        "searchEvents",
                                        "searchProducts"
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "ceo",
                                    "storageKey": null,
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "customUrl",
                                            "variableName": "customUrl",
                                            "type": "String"
                                        }
                                    ],
                                    "concreteType": "User",
                                    "plural": false,
                                    "selections": [
                                        (v1 /*: any*/),
                                        (v4 /*: any*/),
                                        (v5 /*: any*/),
                                        (v3 /*: any*/),
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "disableJoinMyTeam",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        (v2 /*: any*/),
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "trinityDealerId",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "profile",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Profile",
                                            "plural": false,
                                            "selections": [
                                                (v7 /*: any*/),
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "summary",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "city",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "state",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "zip",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                (v1 /*: any*/)
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "CeoHomePage_Query",
            "id": null,
            "text": "query CeoHomePage_Query(\n  $customUrl: String!\n) {\n  viewer {\n    id\n    ...CeoHomePage_viewer_4p0U5i\n  }\n}\n\nfragment CeoHomePage_viewer_4p0U5i on Viewer {\n  user {\n    id\n    userId\n    ...CeoProfile_user\n    role\n    publicId\n    cart {\n      id\n      eventId\n    }\n    shoppingWithCeoUser {\n      publicId\n      id\n    }\n    ceo(customUrl: $customUrl) {\n      id\n      userId\n      publicId\n      firstName\n      disableJoinMyTeam\n      lastName\n      trinityDealerId\n      profile {\n        image\n        summary\n        city\n        state\n        zip\n        id\n      }\n    }\n  }\n}\n\nfragment CeoProfile_user on User {\n  ...EventsDropDown_user\n  shoppingWithCeoUser {\n    userId\n    firstName\n    id\n  }\n}\n\nfragment EventsDropDown_user on User {\n  ...DropDownAutoComplete_user\n}\n\nfragment DropDownAutoComplete_user on User {\n  ...AuthDialog_user\n  id\n  userId\n  publicId\n  permissions {\n    id\n    oneCommerce {\n      id\n      ceo {\n        access\n      }\n    }\n  }\n  shoppingWithCeoUser {\n    publicId\n    id\n  }\n  DropDownAutoCompleteData: autoCompleteData(first: 25, ceoId: \"none\", searchCEOS: false, searchEvents: false, searchProducts: false) {\n    edges {\n      cursor\n      node {\n        id\n        isCEO\n        image\n        ceoId\n        isEvent\n        isProduct\n        routePath\n        primaryLabel\n        secondaryLabel\n        productCategory\n        __typename\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment AuthDialog_user on User {\n  id\n  role\n  email\n  lastName\n  firstName\n  hasSSOAccount\n  shoppingWithCeoUser {\n    userId\n    id\n  }\n  cart {\n    id\n    eventId\n    eventHostFirstName\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '345f7dfba1bd80962abaa4fcde26a5e5';
export default node;
